import { PixErrorType } from './type'
import Visual from './Visual'

const PixError = ({ orderId, user }: PixErrorType) => {
  return <Visual orderId={orderId} user={user}/>
}

export default PixError
